import Vue from "vue";
import dictionariesService from "@/services/dictionaries";
import store from "@/store/";

const state = {
  dictionaries: {},
  loadings: {}
};

const mutations = {
  SET_DICTIONARY(state, { dictionaryName, dictionary }) {
    Vue.set(state.dictionaries, dictionaryName, dictionary);
    Vue.set(state.loadings, dictionaryName, false);
  },
  SET_LOADING(state, dictionaryName) {
    Vue.set(state.loadings, dictionaryName, true);
  }
};

const actions = {
  init() {},

  async loadDictionary({ commit }, dictionaryName) {
    commit("SET_LOADING", dictionaryName);
    const dictionary = await dictionariesService.getDictionary(dictionaryName);
    commit("SET_DICTIONARY", { dictionaryName, dictionary });
  },

  getDictionary({ state, dispatch }, dictionary) {
    let name = dictionary;
    let force = false;

    if (typeof dictionary === "object") {
      name = dictionary.name;
      force = dictionary.force;
    }

    return new Promise(async resolve => {
      if (force || !state.dictionaries[name]) {
        //wait for loading if already requested the same dict
        if (state.loadings[name]) {
          const unwatch = store.watch(
            () => state.dictionaries[name],
            () => {
              resolve(state.dictionaries[name]);
              unwatch();
            }
          );
        } else {
          await dispatch("loadDictionary", name);
          resolve(state.dictionaries[name]);
        }
      } else {
        resolve(state.dictionaries[name]);
      }
    });
  }
};

export default {
  namespaced: true,
  mutations,
  actions,
  state
};
